import { takeLatest, call, put } from 'redux-saga/effects'
import myCertificatesList from 'api/certificates/List'
import * as fromActions from 'store/actions/certificates.action'

async function getList() {
  return myCertificatesList()
}

function* myCertificateListEffectSaga() {
  try {
    const { data } = yield call(getList)
    yield put(fromActions.Actions.myCertificateListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* myCertificateListWatcherSaga() {
  yield takeLatest(fromActions.GET_MY_CERTIFICATES, myCertificateListEffectSaga)
}
